const ISSUE_TYPE =
    Object.freeze(
        {
            SEXUALLY_EXPLICIT: 1,
            POSSIBLY_UNDERAGE: 2,
            VIOLENT_OR_PROHIBITED_CONTENT: 3,
            SCAM_OR_MISLEADING: 4,
            OTHER: 0,
        }
    );

export default ISSUE_TYPE;
